import markerPopup from './marker';
import coursePopup from './course';

export default {
  marker: markerPopup,
  course: coursePopup,
};
